import { filter } from 'lodash';
import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import { ICompany } from './company.model';
import { IUserInfo ,AuthService} from '../shared/core/index';
import { IContact } from './contact.model';
import { IAddressBookSearchData } from './address-book-search-data.model';
import { HttpService } from '../shared/core/http.service';

@Injectable()
export class AddressBookService {

    private _userInfo: IUserInfo;
    private _addressBookUrl = new URL('addressbook', process.env.API_URL).toString();
    private _companyUrl = new URL('addressbook/company', process.env.API_URL).toString();

    constructor(private _httpService: HttpService, private _authService: AuthService) {
        this._authService.subscribeToLoginService().subscribe(r => { this._userInfo = r });
    }
    searchCompany(searchData: IAddressBookSearchData): Observable<string> {
        
        console.log('calling searchCompany() from ' + this._addressBookUrl);
        var body = JSON.stringify(searchData);
        return this._httpService.httpPost(this._addressBookUrl, body)
            .map((response: Response) => {
            return this.mapListSearchData(response);
        })
            .do(data => data)
            .catch(this.handleError);
    }
    getCompanies(searchData: IAddressBookSearchData): Observable<IAddressBookSearchData> {

        console.log('calling getCompanies() from ' + this._addressBookUrl);
        var body = JSON.stringify(searchData);
        return this._httpService.httpPost(this._addressBookUrl, body)
        .map((response: Response) => {
            return this.mapListSearchData(response);
        })
            .do(data => data)
            .catch(this.handleError);
    }
    mapListSearchData(response: Response): IAddressBookSearchData {
        var ret = this.toListSearchData(response.json());
        return ret;
    }
    toListSearchData(data: any): IAddressBookSearchData {
        if (data) {
            console.log(data);
            let listSearchData: IAddressBookSearchData = new IAddressBookSearchData();
            listSearchData.filterString = data.FilterString;
            listSearchData.pageStartIndex = data.PageStartIndex;
            listSearchData.pazesize = data.Pazesize;
            listSearchData.resultSet = data.ResultSet;
            listSearchData.sortBy = data.SortBy;
            listSearchData.sortOrder = data.SortOrder;
            listSearchData.totalNumberOfRecords = data.TotalNumberOfRecords;
            listSearchData.resultSet = [];
            if (data.ResultSet) {
                data.ResultSet.forEach(element => {
                    listSearchData.resultSet.push(this.toCompany(element));
                });
            }
            return listSearchData;
        }
    }
    getCompany(searchData: IAddressBookSearchData): Observable<IAddressBookSearchData> {

        return this.getCompanies(searchData);
    }

    saveCompany(company: ICompany): Observable<ICompany> {

        if (company.id) {
            return this.updateCompany(company);
        }
        return this.createCompany(company);
    }

    createCompany(company: ICompany): Observable<ICompany> {

        var companyCopy: ICompany;

        companyCopy = JSON.parse(JSON.stringify(company));

        console.log('calling createCompany() at ' + this._companyUrl + ' for company: ' + JSON.stringify(companyCopy));

        var body = JSON.stringify(companyCopy);

        if(body.indexOf("<") !== -1 || body.indexOf(">") !== -1){
            console.log('AntiXssMiddleware angled brackets ("<", ">") in your input(s).');
            return Observable.throw("AntiXssMiddleware");
        }

        return this._httpService.httpPost(this._companyUrl, body)
            .map((p: Response) => this.toCompany(p.json()))
            .catch(this.handleError);

    }

    updateCompany(company: ICompany): Observable<ICompany> {

        var companyCopy: ICompany;

        companyCopy = JSON.parse(JSON.stringify(company));

        console.log('calling updateCompany() at ' + this._companyUrl + ' for company: ' + JSON.stringify(companyCopy));

        var body = JSON.stringify(companyCopy);

        if(body.indexOf("<") !== -1 || body.indexOf(">") !== -1){
            console.log('AntiXssMiddleware angled brackets ("<", ">") in your input(s).');
            return Observable.throw("AntiXssMiddleware");
        }

        return this._httpService.httpPut(this._companyUrl, body)
            .map((p: Response) => this.toCompany(p.json()))
            .catch(this.handleError);

    }

    deleteCompany(id: string): Observable<boolean> {

        if (!id) {
            console.error('cannot delete an empty company, try passing the id...');
            return Observable.of(false);
        }

        let url = new URL(id, this._companyUrl + '/').toString();
        console.log('companyService.deleteCompany() at ' + url + ' for company: ' + JSON.stringify(id));

        return this._httpService.httpDelete(url)
            .map((p: Response) => {
                //let body= p.json();
                //return body || {}
                console.log('deleteCompany');
                return Observable.of(true);
            })
            .catch(this.handleError);

    }

    mapCompanies(response: Response): ICompany[] {
        
        let body = response.json();

        var ret = body.Companies.map(r => this.toCompany(r));
        console.log('companyService.mapcompanys(...) >> company after mapping:' + JSON.stringify(ret));
        return ret;
    }

    toCompany(r: any): ICompany {
        let company = <ICompany>
            ({
                id: r.Id,
                name: r.Name,
                isSelected: false,
                notes: r.Notes
            });
        company.contacts = new Array<IContact>();

        //'clean' the first contact if it's the placeholder 
        if (r.Contacts.length == 1){
            if (r.Contacts[0].Name === '[Default]'){
                r.Contacts[0].Name = '';
            }
        }
        

        if (r.Contacts){
            r.Contacts.forEach(contact => {
                let item = this.toContact(contact);
                if (contact.IsDefault){
                    company.defaultContact = this.toContact(contact);
                }
                company.contacts.push(item);
            });
        }

        console.log('companyService.toCompany(..) >>> ret company: ' + JSON.stringify(company));

        return company;
    }
    toContact(c: any): IContact{
        let contact = <IContact>({
            id: c.Id,
            name: c.Name,
            contactTitle: c.ContactTitle,
            address: c.Address,
            address2: c.Address2,
            city: c.City,
            state: c.State,
            zipCode: c.ZipCode,
            country: c.Country,
            phoneNumber: c.PhoneNumber,
            phoneNumber2: c.PhoneNumber2,
            phoneNumber3: c.PhoneNumber3,                        
            cellNumber: c.CellNumber,
            faxNumber: c.FaxNumber,
            email: c.Email,
            notes: c.Notes,
            isDefault: c.IsDefault,
        });
        return contact;
    }
    getFilters(): any {
        return {};
    }

    private handleError(error: Response) {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        console.error('companyService.handleError(...() >>> There has been an error while calling api, error:', error);
        return Observable.throw(error || 'Server error');
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/address-book/address-book.service.ts